import { Dispatch } from 'redux';
import {
    FeatureFlag,
    setFeatureFlags,
    setFeatureFlagsSettled,
    setLoadingFeatureFlags
} from './featureFlagSlice';
import { axios } from '../../services/axiosService';

// App.tsx re-dispatches getFeatureFlags whenever the authUser object identity
// changes, so several requests can be in flight at once. Without sequencing the
// last response to *arrive* wins rather than the last one requested, and a slow
// anonymous response can overwrite a signed-in user's flags for the session.
let requestSeq = 0;

export const getFeatureFlags = (userId: undefined | null | string) => async (dispatch: Dispatch) => {
    const seq = ++requestSeq;
    let failed = false;
    dispatch(setLoadingFeatureFlags(true));

    try {
        const featureFlags = (await axios.get('/featureflags', { params: { id: userId } })).data as FeatureFlag[];
        if (seq !== requestSeq) {
            // Superseded while in flight — drop it without touching state.
            return;
        }
        // Flags before the settled signal: flipping settled first leaves a
        // render where the fetch looks done but the list is still empty.
        dispatch(setFeatureFlags(Array.isArray(featureFlags) ? featureFlags : []));
    } catch (err) {
        console.error(err);
        failed = true;
    } finally {
        if (seq === requestSeq) {
            dispatch(setFeatureFlagsSettled({ userId: userId ?? null, error: failed }));
            dispatch(setLoadingFeatureFlags(false));
        }
    }
};

export const getFeatureFlag = (name: string) => (featureFlags: FeatureFlag[]) => {
    const result = featureFlags.find(obj => obj.name === name);
    return result;
};
